export default function IconRed() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 2" fill="none">
            <path d="M0 2H16V0H0V2Z" fill="currentColor" />
        </svg>
    );
}
